module.exports = __webpack_public_path__ + "resources/img/sp_calculator.d05e9fe3c7897c2728df5111df1b3d04.png";